import styled from 'styled-components';
import { BLACK } from '../../theme';

export const LegalContainer = styled.div`
  table, td {
    border: 1px solid ${BLACK};
  };
`;
